import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-exclamation-icon',
  templateUrl: 'exclamation-icon.component.html'
})
export class ExclamationIconComponent {
  constructor() {}
}
